import { render } from "./NewCreateFulfilmentPage.vue?vue&type=template&id=5e8656e7"
import script from "./NewCreateFulfilmentPage.vue?vue&type=script&lang=js"
export * from "./NewCreateFulfilmentPage.vue?vue&type=script&lang=js"

import "./NewCreateFulfilmentPage.vue?vue&type=style&index=0&id=5e8656e7&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__